import { FC, useEffect, useMemo, useState } from 'react'
import MainHeader from '../../components/Calendar/Header'
import { useDispatch, useSelector } from '../../store/index'
import CreditCard from '../../components/Billing/CreditCard';
import BillingInformation from '../../components/Billing/BillingInformation';
import { getBillingDetailsThunk, updateCardThunk, saveBillingAddressThunk } from '../../store/billing/thunks';
import { resetBillingStateAction } from '../../store/billing/slice';
import { TBillingAddressValues, TCardFormValues } from '../../models/form';

import { push } from 'connected-react-router'
import { isFulfilled } from '@reduxjs/toolkit'
import './Billing.scss'
import { useToasts } from 'react-toast-notifications'
import { TOAST_MESSAGE } from '../../components/UI/ToastNotification/ToastNotification';
import { setHeaderView } from '../../store/application/slice'
import { HEADER_VIEW } from '../../store/application/types'
import Preloader from '../../components/Preloader'

interface BillingProps { }

const Billing: FC<BillingProps> = (props) => {
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const [isEditable,setIsEditable] = useState(true);
  const [action,setAction] = useState('');
  const {billingAddress,card,planDetails,inProgress,error} = useSelector((state)=>({
    billingAddress: state.billing.billingAddress,
    card:state.billing.card,
    planDetails:state.billing.planDetails,
    inProgress: state.billing.inProgress,
    error:state.billing.error
}));


  useEffect(() => {
    dispatch(setHeaderView(HEADER_VIEW.BILLING));
    dispatch(getBillingDetailsThunk())
    return ()=>{
      dispatch(resetBillingStateAction());
      setAction('')
    }
  }, [])


  const saveCard = async(values:{data:TCardFormValues,state:any}) => {
    setAction('card')
    const { data , state:{touched}} = values;
    const cardResponse  = await dispatch(updateCardThunk(data));
    if(isFulfilled(cardResponse)){
      dispatch(getBillingDetailsThunk())
      addToast(TOAST_MESSAGE.CARD_UPDATED, { appearance: 'success' })
    }
  }

  const saveBillingDetails = async (values:TBillingAddressValues) => {
    setAction('billing')
    const billingResponse = await dispatch(saveBillingAddressThunk(values))
    if(isFulfilled(billingResponse)){
      dispatch(getBillingDetailsThunk())
      addToast(TOAST_MESSAGE.BILLING_ADDRESS_SAVED, { appearance: 'success' })
    }
  }

  return (
    <div className='billing-page'>
      <MainHeader />
      <div className="billing-page__wrapper">
        <div className='billing-page__container'>
          <div className="billing-page__container__header">CURRENT SUBSCRIPTION</div>
          <div className="billing-page__container__content">
            <table>
              <thead>
                <tr>
                  <th>USER</th>
                  <th>SOCIAL MEDIA ACCOUNTS</th>
                  <th className="text-left">SUBSCRIPTION PRICE</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{planDetails?.usercount}</td>
                  <td>{planDetails?.socialcount}</td>
                  {planDetails?<td className="text-left">
                    {/* <a className="view-plan-link">View subscription pricing</a> */}
                    {planDetails.status === 'trialing' ? <>Free trial
                    <a className="view-plan-link">{planDetails.remainingdays > 0? planDetails.remainingdays : 0}{' '}days remaining</a></>: `US$`+ planDetails.price}
                  </td>:null}
                  <td>
                    {/* <a className="cancel-link">Cancel subscription</a> */}
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div className="billing-page__form-wrapper">
          <div className="billing-address">
            <h3 className="header">Billing Information</h3>
            <BillingInformation billingAddress={billingAddress} inProgress={action === 'billing' && inProgress} error={action === 'billing'?error:null} saveCallBack={saveBillingDetails} isEditable={isEditable} />
          </div>
          <div className="card-details">
            <h3 className="header">Payment Method</h3>
            <CreditCard cardDetails={card} inProgress={action === 'card' && inProgress} error={action === 'card'?error:null} saveCallBack={saveCard} isEditable={isEditable}  />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Billing
